import { render, staticRenderFns } from "./ReferencesKeiAnswers.vue?vue&type=template&id=5119a46b"
import script from "./ReferencesKeiAnswers.vue?vue&type=script&lang=js"
export * from "./ReferencesKeiAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports